import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Button from 'components/Button';
import Input from 'components/Input';

import useDomains from '../../../model/useDomains';

import SVG from 'components/SVG';

import crossSVG from 'shared/img/cross-transparent.svg';

import './DomainsModal.scss';

const b = block('domains-modal-desktop');

const DomainsModal = ({ closeFunction, modalState, openModal, sendDomainRequest }) => {
  const locale = useSelector(state => state.locale.locale);

  return (
    <div className={b()}>
      <SVG className={b('cross').toString()} svgProps={{ svg: crossSVG }} onClick={closeFunction} />
      <div className={b('title')}>{modalState.type === 'request' ? locale.comment : locale.requestDomain}</div>
      <div className={b('content')}>
        {modalState.type === 'request' ? (
          <div className={b('comment')}>{modalState.domainRequestText}</div>
        ) : (
          <>
            <div className={b('input')}>
              <div className={b('input-label')}>{locale.domain}</div>
              <div className={b('input-field')}>
                <Input
                  value={modalState.domainRequestText}
                  onChange={e =>
                    openModal({ isOpen: true, type: 'my-domains', domainRequestText: e.currentTarget.value })
                  }
                  placeholder={locale.domain}
                />
              </div>
            </div>
            <div className={b('text', { small: true })}>{locale.requestDomainDescription1}</div>
            <div className={b('text')}>{locale.requestDomainDescription2}</div>
            <div className={b('text')}>{locale.requestDomainDescription3}</div>
            <div className={b('button')}>
              <Button callBack={() => sendDomainRequest(closeFunction)} text={locale.sendRequest} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DomainsModal;
